export default "__VITE_ASSET__BCioFEQk__"